<template>
  <a-modal v-model="showModal" :centered="true" :dialog-style="{ margin: '0px', width: '100px !important' }" @cancel="hide" @ok="hide" :footer="null" :width="750" class="verify-modal">
    <div class="m-128 text-center">
      <div class="mail-box">
        <a-icon type="mail" theme="twoTone" twoToneColor="white" />
      </div>
      <a-input class="w-75 mb-4" :size="'large'" v-model="email" placeholder="Enter email address" />

      <p>
        If you have not verified your account, please check your email and verify the account, else you can close this window and Login to proceed further.
      </p>
      <div class="error-container" v-if="isError">
        <div class="error-item" v-if="isError">Email is required</div>
      </div>
      <div class="d-flex justify-content-around flex-wrap" style="margin-top: 54px">
        <a-button type="ghost" size="large" class="left-radius right-radius dovemed-button mt-2" :style="{ border: '1px solid #fff' }" @click="hide"><b class="font-white">Close</b></a-button>
        <a-button class="left-radius right-radius dovemed-button mt-2" type="ghost" size="large" :loading="loading" :style="{ border: '1px solid #fff' }" @click="resend"
          ><b class="font-white">Resend Confirmation Email</b></a-button
        >
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import axios from "axios"
const AppRepository = RepositoryFactory.get("app")

export default {
  name: "EmailVerificationModal",
  data() {
    return {
      showModal: false,
      email: null,
      isError: false,
      loading: false,
    }
  },
  created() {
    // console.log(this.authUser, "authuser emal verification");
    console.warn("Modals/EmailVerification.vue is created")
  },
  watch: {
    email: function(val) {
      !val ? (this.isError = true) : (this.isError = false)
    },

    isError: function(newVal, oldVal) {
      if (newVal) {
        console.log("psl verify")
      }
    },
  },
  methods: {
    show() {
      this.showModal = true
      if (this.authUser) {
        this.email = this.authUser.user.email
      }
    },
    // http://localhost:8080/#/Multiple-Sclerosis/signup/userProfile/yourStory
    hide() {
      this.logout()
      this.showModal = false
    },

    resend() {
      if (this.authUser.user.email) {
        // this.loading = true;
        // AppRepository.resendVerificationEmail({
        //   email: this.authUser.user.email
        // })
        //   .then(res => {
        //     this.loading = false;
        //     this.$notification.success({
        //       message: "Success",
        //       description: `Send successfully.`
        //     });
        //   })
        //   .catch(err => {
        //     const message = err.response.data.message;
        //     this.$notification.error({
        //       message: "Error",
        //       description: message
        //     });
        //     this.loading = false;
        //     this.showModal = false;
        //     this.logout();
        //   });

        axios
          .post(`${process.env.SSO_BASE_URL}/api/v1/signupresend/`, {
            email: this.email,
          })
          .then(res => {
            console.log(res, "sent")
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.isError = true
      }
    },
  },
}
</script>

<style lang="scss">
.verify-modal {
  .ant-modal-content {
    background-color: #0f74bd !important;
    border-radius: 10px;
    padding: 100px 85px;
    @media screen and (max-width: 580px) {
      padding: 0;
    }
    .ant-modal-close-x {
      font-size: 20px !important;
    }
    .mail-box {
      margin: 0 auto 35px;
      height: 75px;
      width: 75px;
      background: #21d35a;
      border-radius: 50%;
      padding: 10px;
      font-size: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    h1.verify-title {
      margin-bottom: 24px;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 22px;
      color: #fff !important;
    }
    p {
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
      color: #fff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/EmailVerification.vue